import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export class DateUtil {
  static formatDate(d: string, format: string): string {
    return dayjs(d).format(format)
  }

  static formatShort(d: string): string {
    return this.formatDate(d, 'DD/MM/YYYY')
  }

  static formatMedium(d: string): string {
    return this.formatDate(d, 'DD/MM/YYYY HH:mm')
  }

  static formatFull(d: string): string {
    return this.formatDate(d, 'DD/MM/YYYY HH:mm:ss')
  }

  /**
   * Lấy ngày cuối cùng của năm
   * @param year - Năm cần lấy ngày cuối (mặc định là năm hiện tại)
   * @returns Chuỗi ngày định dạng DD/MM/YYYY
   */
  static getLastDayOfYear(year?: number): string {
    const targetYear = year ?? dayjs().year()
    const lastDay = dayjs(`${targetYear}-12-31`)
    return lastDay.format('DD/MM/YYYY')
  }
}

/**
 * Kiểm tra xem ngày hiện tại có nằm trong khoảng thời gian tri ân lookback (26/12 - 31/12) không
 * @returns boolean - true nếu đang trong thời gian tri ân
 */
export function isLookbackGratitudePeriod(): boolean {
  // const now = dayjs()

  // const startDate = dayjs(`2025-12-22`).startOf('day')
  // const endDate = dayjs(`2025-12-31`).endOf('day')

  // return (
  //   (now.isAfter(startDate) && now.isBefore(endDate)) ||
  //   now.isSame(startDate, 'day') ||
  //   now.isSame(endDate, 'day')
  // )
  return false
}
